export const HELP_TYPE = {
  GET: 'get',
  GIVE: 'give',
};
